const t = {
  name: "SkipUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.0001 7H7.00006V9H17.0001V7Z" fill="currentColor"/>
<path d="M12.0002 13.4142L16.0002 17.4142L17.4144 16L12.0002 10.5858L6.58594 16L8.00015 17.4142L12.0002 13.4142Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SkipUp
};
